import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-iyc-metadata',
  templateUrl: './iyc-metadata.component.html',
  styleUrls: []
})
export class IycMetadataComponent {
  @Input() chatdata: any;
  @Input() configdata: any; // Added line to accept configdata as input
  metadata: any;
  error: boolean = false;
  errorMessage: string = '';
  constructor() { }

  removeDuplicatesAndJoin(pages: number[]): string {
    const uniquePages = [...new Set(pages)];
    return uniquePages.join(',');
  }
}
